import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { RangeMonthsHeaderComponent } from './range-months-header/range-months-header.component';
import { getOneAndAHalfYearsFromNow } from '../../helpers/datepicker.helper';

declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-multiple-months-datepicker',
    templateUrl: './multiple-months-datepicker.component.html',
    styleUrls: ['./multiple-months-datepicker.component.scss'],
    standalone: false
})
export class MultipleMonthsDatepickerComponent {
  @ViewChild('selectDateModal') selectDateModalEl: ElementRef;
  @ViewChild('tooltipElement') tooltipElementEl: ElementRef;

  customCalendarHeader = RangeMonthsHeaderComponent;

  todayDate = new Date(Date.now());
  maxDate = getOneAndAHalfYearsFromNow();
  calendars: number[] = [];

  @Input() dateSelected: Date;
  @Input() itemsAlignedVertically = true;
  @Input() changeDateDisabled = false;
  @Input() set numberOfCalendars(value: number) {
    this.calendars = Array.from(Array(value).keys());
  };

  @Output() setNewDate = new EventEmitter<Date>();
  @Output() resetInstallationDate = new EventEmitter();

  openSelectDateDialog(showInfoButton = false) {
    jQuery(this.selectDateModalEl.nativeElement).modal('show');
    this.tooltipElementEl.nativeElement.style.visibility = showInfoButton ? 'visible' : 'hidden';
  }

  selectDate(date: Date) {
    this.setNewDate.emit(date);
    this.closeModal();
  }

  closeModal() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.selectDateModalEl.nativeElement).modal('hide');
  }

  resetExpectedProjectDate() {
    this.resetInstallationDate.emit();
  }
}
